;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');
	var Collection = APP.module('Collection');

	Model.ContactUs = Backbone.Model.extend({
		url: 'contact',
		schema: {
			name:  {title: 'Name*'},
			email: {title: 'Email:*', validators: ['required', 'email']},
			category: {title:'Category', type: 'Select'},

			question: {title: 'Question*', type: 'TextArea'}
		}
	});

}(window, APP, Backbone, Marionette, $, _));